// utils/authUtils.js

export const getParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    token: params.get("token"),
    source: params.get("source"),
    brand_name: params.get("brand_name"),
    logo_url: params.get("logo_url"),
  };
};
